import { gql } from '@apollo/client';
import { BASE_PLOT_FRAGMENT } from 'graphql/secure/fragments/plot.fragment';

export const CREATE_PLOTS = gql`
  mutation CreatePlots($inputs: [CreatePlotInput]!) {
    createPlots(inputs: $inputs) {
      plots {
        ...basePlotValues
      }
    }
  }
  ${BASE_PLOT_FRAGMENT}
`;

export const UPDATE_PLOTS = gql`
  mutation UpdatePlots($inputs: [UpdatePlotInput]!) {
    updatePlots(inputs: $inputs) {
      plots {
        ...basePlotValues
      }
    }
  }
  ${BASE_PLOT_FRAGMENT}
`;

export const DELETE_PLOTS = gql`
  mutation DeletePlots($ids: [UUID]!) {
    deletePlots(ids: $ids) {
      ids
    }
  }
`;
